export const CreditCardCategoryIdEnum = {
    Associate: 0,
    CVO: 1,
    TravelCorp: 2,
    TravelProv: 3,
    CustomerCare: 4,
};

export const CreditCardCategoryEnum = {
    [CreditCardCategoryIdEnum.Associate]: 'Associate',
    [CreditCardCategoryIdEnum.CVO]: 'CVO',
    [CreditCardCategoryIdEnum.TravelCorp]: 'Travel-Corp',
    [CreditCardCategoryIdEnum.TravelProv]: 'Travel-Prov',
    [CreditCardCategoryIdEnum.CustomerCare]: 'Customer Care',
};

export default CreditCardCategoryEnum;
